module.exports = __webpack_public_path__ + "img/sfz2.491b88d1.png";